// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__kzOFL","title":"styles_title__hAjgW","gamesContainer":"styles_gamesContainer__ei__M"};